import './DeliveryMapPopup.css';
import AdaptivePopup from '../../../../../AdaptivePopup/AdaptivePopup';
import AddressMap from '../../../../Settings/Integrations/Delivery/AddressMap/AddressMap';
import PopupControlBtn from '../../../../../DesktopPopup/components/PopupCloseBtn/PopupCloseBtn';

function DeliveryMapPopup({ isOpen, onClose, address, coords }) {
    return (
        <AdaptivePopup
            isOpen={isOpen}
            handleClose={onClose}
            popupName={'delivery-map'}
        >
            <div className="delivery-info__map-popup">
                <div className="delivery-info__map-popup-head">
                    <div>
                        <p className="delivery-info__popup-title">Адрес на карте</p>
                        <p className="delivery-info__popup-subtitle">{address}</p>
                    </div>
                    <PopupControlBtn
                        onClick={onClose}
                        POPUP_NAME={'delivery-map'}
                        type={'close'}
                    />
                </div>
                <AddressMap
                    className={'delivery-info__map'}
                    location={{
                        center: coords,
                        zoom: 12,
                    }}
                    disabled={false}
                />
            </div>
        </AdaptivePopup>
    );
}

export default DeliveryMapPopup;
